export default {
  SET_CURRENCY(state, currencyCode) {
    state.currencyCode = currencyCode
  },
  SET_TENANT(state, tenant) {
    state.tenant = tenant
  },
  UPDATE_TENANT(state, tenant) {
    state.tenant = tenant
  },
}
